<template>
  <div v-for="(module, index) in permissions" :key="index">
    <q-card
      v-if="module.visible"
      :class="[!showSelectAllReset ? 'q-py-md' : 'q-mb-md']"
      class="full-width"
      flat
      v-bind="$attrs"
    >
      <PExpansionItem
        v-model="expand[index]"
        :label="module.name"
        :caption="`Assign roles, customize permissions, and track ${module.name} activity with ease`"
      >
        <PermissionsTable
          v-model="module.useCases"
          :highlight-changes="highlightChanges"
          :initial-permissions="initialPermissions?.[index]?.useCases"
          :role-permissions="role.permissions?.[index]?.useCases"
          :show-select-all-reset="showSelectAllReset"
        />
        <span
          v-if="highlightChanges"
          class="text-xs text-weight-medium text-neutral-90 q-px-md"
        >
          Note:
          <span class="rounded circle bg-info-60 q-mx-xxs"></span> The blue
          color indicates that the permissions has been customized.
        </span>
      </PExpansionItem>
    </q-card>
    <q-separator
      v-if="!showSelectAllReset && module.visible"
      class="full-width"
    />
  </div>
</template>

<script setup>
defineProps({
  highlightChanges: {
    type: Boolean,
    default: false,
  },
  showSelectAllReset: {
    type: Boolean,
    default: false,
  },
});

const { initialPermissions, role, formState } = storeToRefs(
  useRoleManagementStore(),
);
const permissions = defineModel({ type: Array });
const expand = ref({});

watch(
  () => unref(formState).open,
  (val) => {
    if (val) {
      expand.value = {};
    }
  },
);
</script>
<style scoped>
.circle {
  display: inline-block;
  width: 10px;
  height: 10px;
  vertical-align: middle;
}
</style>
